
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getBindSta } from "@/api/api-rate";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiModelAdd extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("ratamanage.bindSta");

  private delayFreeMinutes = 0;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("ratamanage.index"),
      key: "index",
      resizable: true,
      width: 80,
      slot: "index"
    },
    {
      title: i18n.t("oprName"),
      key: "oprName",
      minWidth: 120
    },
    {
      title: i18n.t("ratamanage.stationName"),
      key: "stationName",
      resizable: true,
      minWidth: 140,
      slot: "stationName"
    },
    {
      title: i18n.t("ratamanage.stationAddress"),
      key: "stationAddress",
      resizable: true,
      minWidth: 200
    }
  ];
  private feePkId = "";

  public open(item: objAny, unit: string, unitType: string) {
    console.log(item, unit, unitType);

    this.modalShow = true;
    this.feePkId = item.feePkId;
    if (unitType == "oms") {
      this.tableColumns = [
        {
          title: i18n.t("ratamanage.index"),
          key: "index",
          resizable: true,
          width: 80,
          slot: "index"
        },
        {
          title: i18n.t("ratamanage.stationName"),
          key: "stationName",
          resizable: true,
          minWidth: 140,
          slot: "stationName"
        },
        {
          title: i18n.t("ratamanage.stationAddress"),
          key: "stationAddress",
          resizable: true,
          minWidth: 200
        }
      ];
    }
    this.tableList = [];
    this.getBindStaDeatil();
  }
  async getBindStaDeatil() {
    this.loading = true;
    const ret = await getBindSta({ feePkId: this.feePkId });
    if (ret.status === this.$config.apiStatus) {
      console.log(ret.data);
      if (ret.data[0]) {
        const staVos = ret.data[0].staVos || [];
        const entVos = ret.data[0].entVos || [];
        this.tableList = staVos.concat(entVos);
      } else {
        this.tableList = [];
      }
    }
    this.loading = false;
  }
  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  public convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }
  /**
   * 合并时间 08:00-12:00
   */
  public joinDate(data: string[]) {
    let timeArr = "";
    if (data.length > 0) {
      timeArr =
        this.convertStringToTimes(data[0]) +
        "-" +
        this.convertStringToTimes(data[1]);
      return timeArr;
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
